// extracted by mini-css-extract-plugin
export var dividerLine = "_6v-3";
export var itemImage = "_6v-9";
export var lightDivider = "_6v-4";
export var modalContent = "_6v-5";
export var modalContentCompact = "_6v-6";
export var productCard = "_6v-a";
export var productImage = "_6v-b";
export var productImageCompact = "_6v-7";
export var productImagePlaceholder = "_6v-c";
export var productImagePlaceholderCompact = "_6v-8";
export var progressBarBackground = "_6v-1";
export var progressBarContainer = "_6v-0";
export var progressBarFill = "_6v-2";